import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=bb5bdcde&scoped=true&"
import script from "./SubscriptionView.vue?vue&type=script&lang=js&"
export * from "./SubscriptionView.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionView.vue?vue&type=style&index=0&id=bb5bdcde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5bdcde",
  null
  
)

export default component.exports